(function() {
  'use strict';

  var quizInit = function() {
    var currentStep = 0;
    var totalSteps = 5;
    var answers = {};

    var intro = document.getElementById('quiz-intro');
    var body = document.getElementById('quiz-body');
    var result = document.getElementById('quiz-result');
    var progressBar = document.getElementById('quiz-progress-bar');
    var startBtn = document.getElementById('quiz-start-btn');
    var emailOverlay = document.getElementById('quiz-email-page');
    var emailForm = document.getElementById('quiz-email-form');
    var emailSkip = document.getElementById('quiz-email-skip');
    var discountBanner = document.getElementById('quiz-discount-banner');

    if (!startBtn || !body) return;

    // --- Helpers ---
    function showStep(num) {
      var steps = body.querySelectorAll('.quiz-step');
      steps.forEach(function(s) { s.style.display = 'none'; });
      var target = body.querySelector('[data-step="' + num + '"]');
      if (target) target.style.display = 'block';
    }

    function updateProgress() {
      if (progressBar) {
        progressBar.style.width = ((currentStep / totalSteps) * 100) + '%';
      }
    }

    function buildResultText() {
      var resultText = document.getElementById('quiz-result-text');
      if (!resultText) return;

      var goal = answers[1] || 'focus';
      var challenge = answers[3] || 'fog';

      var goalMap = {
        'focus': 'razor-sharp, distraction-proof focus',
        'memory': 'faster recall and stronger working memory',
        'energy': 'clean mental energy that lasts all day',
        'stress': 'the ability to perform under pressure without burning out'
      };

      var challengeMap = {
        'afternoon': 'the afternoon wall that kills your second half',
        'fog': 'the brain fog that makes clear thinking feel impossible',
        'burnout': 'the accumulated burnout that\'s degrading your capacity',
        'anxiety': 'the stress and overthinking that blocks your best work'
      };

      var goalText = goalMap[goal] || goalMap['focus'];
      var challengeText = challengeMap[challenge] || challengeMap['fog'];

      resultText.textContent = 'You need ' + goalText + ' \u2014 and a formula that directly addresses ' + challengeText + '. Flow State delivers all five cognitive pathways in a single scoop at clinically effective doses. No caffeine. No guesswork. No half-measures.';
    }

    function revealResults(showDiscount) {
      if (emailOverlay) emailOverlay.style.display = 'none';
      if (result) {
        if (showDiscount) {
          result.classList.add('has-discount');
          if (discountBanner) discountBanner.style.display = 'flex';
        } else {
          result.classList.remove('has-discount');
          if (discountBanner) discountBanner.style.display = 'none';
        }
        result.style.cssText += '; display: flex; flex-direction: column; justify-content: center; min-height: calc(100vh - 104px);';
      }
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }

    // --- Listeners ---
    startBtn.addEventListener('click', function() {
      if (intro) intro.style.display = 'none';
      body.style.display = 'flex';
      currentStep = 1;
      showStep(currentStep);
      updateProgress();
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });

    body.addEventListener('click', function(e) {
      var option = e.target.closest('.quiz-option');
      if (!option) return;
      var step = option.closest('.quiz-step');
      if (!step) return;
      var stepNum = parseInt(step.getAttribute('data-step'));

      step.querySelectorAll('.quiz-option').forEach(function(o) { o.classList.remove('is-selected'); });
      option.classList.add('is-selected');
      answers[stepNum] = option.getAttribute('data-value');

      setTimeout(function() {
        if (stepNum < totalSteps) {
          step.style.display = 'none';
          currentStep = stepNum + 1;
          showStep(currentStep);
          updateProgress();
          window.scrollTo({ top: 0, behavior: 'smooth' });
        } else {
          body.style.display = 'none';
          if (emailOverlay) {
            emailOverlay.style.display = 'flex';
          } else {
            revealResults(false);
          }
          window.scrollTo({ top: 0, behavior: 'smooth' });
          buildResultText();
        }
      }, 300);
    });

    if (emailForm) {
      emailForm.addEventListener('submit', function(e) {
        e.preventDefault();
        var emailInput = document.getElementById('quiz-email-input');
        var email = emailInput ? emailInput.value : '';
        if (!email) return;

        fetch('/contact', {
          method: 'POST',
          headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
          body: 'form_type=customer&utf8=%E2%9C%93&contact[email]=' + encodeURIComponent(email) + '&contact[tags]=quiz,QUIZ10'
        }).catch(function() {});

        revealResults(true);
      });
    }

    if (emailSkip) {
      emailSkip.addEventListener('click', function() {
        revealResults(false);
      });
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', quizInit);
  } else {
    quizInit();
  }
})();
